import { render, staticRenderFns } from "./backend.vue?vue&type=template&id=bfd07998&scoped=true&"
import script from "./backend.vue?vue&type=script&lang=js&"
export * from "./backend.vue?vue&type=script&lang=js&"
import style0 from "./backend.vue?vue&type=style&index=0&id=bfd07998&scoped=true&lang=css&"
import style1 from "./backend.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd07998",
  null
  
)

export default component.exports